module.exports = __webpack_public_path__ + "static/media/przekreslony-kontener.4fe02d04.svg";